// import React from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import Header from './Components/Header';
// import InfoBar from './Components/InfoBar';

// import Home from './Screens/Home';
// import About from './Screens/About';
// import BusinessModule from './Screens/BusinessModule';
// import Services from './Screens/Services';
// import Projects from './Screens/Projects';
// import Contact from './Screens/Contact';
// import Footer from './Components/Footer';
// import OurTeam from './Screens/OurTeam';
// import Team from './Screens/Team';
// import ProjectDetails from './Screens/ProjectDetails';




// function App() {
//   const appStyle = {
//     background: 'linear-gradient(to right, #0f2027, #203a43, #2c5364)',
//     minHeight: '100vh',
//     color: 'black', // optional: ensure text is readable
//   };
//   const sectionStyle = {
//     minHeight: '100vh',
//     overflow: 'hidden',
//     // paddingTop: '100px',
//   };

//   return (
//     <Router>

//       <style
//         dangerouslySetInnerHTML={{
//           __html: `
//         @media print {
//           body {
//             -webkit-print-color-adjust: exact !important;
//             print-color-adjust: exact !important;
//             margin: 0;
//             padding: 0;
//           }
//           .print-section {
//             height: 1122px !important;
//             page-break-after: always !important;
//             page-break-inside: avoid !important;
//             break-inside: avoid !important;
//             overflow: hidden !important;
//           }
//         }
//       `,
//         }}
//       />

//       <div className="print-section" style={sectionStyle}>
//         <Home />
//       </div>
//       <div className="print-section" style={sectionStyle}>
//         <About />
//       </div>
//       <div className="print-section" style={sectionStyle}>
//         <BusinessModule />
//       </div>
//       <div className="print-section" style={sectionStyle}>
//         <Services />
//       </div>
//       <div className="print-section" style={sectionStyle}>
//         <Projects />
//       </div>

//       <Routes>
//         <Route path="/projectdetails" element={<ProjectDetails />} />
//       </Routes>

//       <div className="print-section" style={sectionStyle}>
//         <OurTeam />
//       </div>
//       <div className="print-section" style={sectionStyle}>
//         <Contact />
//       </div>

//       <Footer />

//     </Router>

//   );
// }

// export default App;

// App.js

// import React, { useEffect, useState } from "react";
// import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
// import { CookiesProvider } from "react-cookie";
// import CookieConsent from "./Components/CookieConsent";
// import Nav from "./Navigation/Nav";
// import ScrollToTop from "./Components/ScrollToTop";



// function App() {
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     // Simulate page load
//     const timer = setTimeout(() => {
//       setLoading(false);
//     }, 2000); // show loader for 2 seconds

//     return () => clearTimeout(timer);
//   }, []);
//   return (
//     <CookiesProvider>
//       <Router>
//         <ScrollToTop />
//         {/* Navigation bar (always visible) */}
//         <Nav />

//         {/* Routes (switch between screens) */}


//         {/* Cookie banner/form (always visible) */}
//         <CookieConsent />
//       </Router>
//     </CookiesProvider>
//   );
// }

// export default App;


import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CookiesProvider } from "react-cookie";
import CookieConsent from "./Components/CookieConsent";
import Nav from "./Navigation/Nav";
import SecTeamMemberDetails from "./Screens/SecTeamMemberDetails";
import ProjectDetails from "./Screens/ProjectDetails";
import ScrollToTop from "./Components/ScrollToTop";
import Loader from "./Components/Loader";


function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate page load
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <Loader />; // show loader first
  }

  return (
    <CookiesProvider>
      <Router>
        <ScrollToTop />
        <Nav />

        {/* <Routes>
          <Route path="/team/:id" element={<SecTeamMemberDetails />} />
          <Route path="/project/:id" element={<ProjectDetails />} />

        </Routes> */}

        <CookieConsent />
      </Router>
    </CookiesProvider>
  );
}

export default App;

